import { LanguageToggle } from "@/components/LanguageToggle";
import { useLanguage } from "@/contexts/LanguageContext";

export const TournamentHeader = () => {
  const { t } = useLanguage();
  
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold text-primary">{t("tournament.title")}</h1>
      <LanguageToggle />
    </div>
  );
};